<template>
  <b-col>
    <!-- IF DISPLAY IMAGES IS FALSE, SHOW ITEMS WITHOUT PICTURE -->
    <b-card v-if="!displayImages" no-body class="overflow-hidden customcard" @click="emitOptionsModal(item)">
      <b-row no-gutters>
        <b-col>
          <b-card-body :title="item.name">
            <b-card-text>
              <h5 class="mr-3 card-title item-price">{{item.std_price | toCurrency}}</h5>
              <!-- <b-button variant="dark" class="item-add" @click="emitOptionsModal(item)">Add</b-button> -->
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <!-- DISPLAY IMAGES = TRUE - SHOW PICTURES -->
    <b-card v-else no-body class="overflow-hidden customcard" @click="emitOptionsModal(item)">
      <b-row no-gutters>
        <b-col>
          <b-card-body :title="item.name">
            <b-card-text>
              <b-card-img thumbnail :src="item.image_path" alt="Image" class="rounded-0 item-img"></b-card-img>
              <h5 class="card-title item-price">{{item.std_price | toCurrency}}</h5>
              <!-- <b-button variant="dark" class="item-add" @click="emitOptionsModal(item)">Add to order</b-button> -->
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </b-col>
</template>

<script>
export default {
  name: 'Item',
  props: ['item', 'displayImages'],
  data () {
    return {
    }
  },
  methods: {
    emitOptionsModal(item) {
      this.$emit('optionsemit', item, false);
    }
  }
}
</script>

<style>

.customcard:hover {
  padding: 5px;
  color: white;
  background-color: black;
}

.customcard:active {
  padding: 5px;
  color: white;
  background-color: black;
}

.item-price {
  padding-top: 1rem;
  margin-bottom: 0;
  /* float: left; */
}

.item-add {
  float: right;
  margin-bottom: 1rem;
}

p.card-text {
  font-size: 0.8rem;
}

.item-img {
  width: 9rem;
  height: 7.5rem;
  margin: auto;
  display: block;
  margin-top: 0.25rem;
  padding: 2px;
  border: 1px solid black;
}

.customcard {
    max-width: 320px;
    margin: auto;
    /* width: 50%; */
    margin-top: 2px;
    margin-bottom: 2px;
    color: black;
    text-align: center;
    /* height: 300px; */
}

.customcard h4 {
    font-weight: bold;
    font-size: 125%;
    min-height: 50px;
    overflow-y: hidden;
    margin-top: auto;
    margin-bottom: auto;
}

@media (min-width: 768px) {
  .customcard {
      max-width: 540px;
      margin: auto;
      /* width: 50%; */
      margin-top: 2px;
      margin-bottom: 2px;
  }

  .item-img {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

</style>
